import { styled } from 'styled-components';

import { cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsSplitContentBlockquoteContent_Box_1 = styled.div`
  height: 100%;
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    left: 50%;
    top: 50%;
  }
`;

export const CmsSplitContentBlockquoteContent_Box_2 = styled.div`
  width: 100%;
  padding-inline: ${gutterWidth / 4}px;
  padding-block: ${gutterWidth / 4}px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    width: 50%;
    padding-inline: ${gutterWidth / 2}px;
    padding-block: ${gutterWidth / 2}px;
  }
`;
